<div id="layout-wrapper">
	<!-- Top Bar -->
	<app-topbar *ngIf="showSidebar" (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
	<!-- Side Bar -->
	<app-sidebar *ngIf="showSidebar"></app-sidebar>
	<div class="main-content" [ngClass]="{ 'with-sidebar': showSidebar, 'no-sidebar': !showSidebar }">
		<app-loader *ngIf="isLoading"></app-loader>

		<div class="page-content">
			<div class="container-fluid">
				<!-- Main Content -->
				<router-outlet></router-outlet>
			</div>
		</div>
		<!-- Footer -->
		<app-footer *ngIf="showSidebar"></app-footer>
	</div>
</div>
<!-- Right Side Bar -->
<!-- <app-rightsidebar  (settingsButtonClicked)="onSettingsButtonClicked()"></app-rightsidebar> -->
<!--chat extension-->
<!-- <app-chat-extension></app-chat-extension> -->
